export default __webpack_public_path__ + "static/media/330_store01-jp-web.0c019345.png";